var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37634 15.215C10.324 14.3127 13.7102 14.7012 16.4417 16.3704M6.00712 12.1354C9.77068 10.9931 14.4496 11.5464 17.6487 13.5121M5.42051 8.78015C9.0814 7.66911 15.1668 7.88361 19.0123 10.1664M22.3633 12C22.3633 17.7235 17.7235 22.3633 12 22.3633C6.27652 22.3633 1.63672 17.7235 1.63672 12C1.63672 6.27652 6.27652 1.63672 12 1.63672C17.7235 1.63672 22.3633 6.27652 22.3633 12Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.bcf94bf3fe7f0b659a9ba3847ce9c809.svg";
export { ForwardRef as ReactComponent };